<template>
  <v-tooltip bottom>
    <template slot="activator">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <v-btn
          slot="activator"
          small
          icon
          class="mx-1"
        >
          <v-icon>history</v-icon>
        </v-btn>

        <v-card>
          <v-data-table
            :headers="historyHeaders"
            :items="history"
            no-data-text="Нет данных"
            hide-actions
            class="elevation-1"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td>{{ props.item.state }}</td>
              <td>{{ props.item.createdAt | dateTime }}</td>
              <td>{{ props.item.author }}</td>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              flat
              @click="menu = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </template>
    <span>История</span>
  </v-tooltip>
</template>

<script>
import { getStatesHistory } from "../../../backend/routesApi.js";

export default {
  data() {
    return {
      menu: false,
      history: [],
      historyHeaders: [
        { text: "Статус", sortable: false },
        { text: "Дата изменения", sortable: false },
        { text: "Автор", sortable: false },
      ],
    };
  },
  watch: {
    menu(value) {
      if (value) {
        this.loadHistory();
      }
    },
  },
  methods: {
    async loadHistory() {
      const route = this.$store.getters["customsEntryRegistration/getRoute"];
      if (!route.Id) {
        this.history = [];
      } else {
        this.history = await getStatesHistory(route.Id);
      }
    },
  },
};
</script>
